import { APP_BASE_HREF, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { inject, Inject, Injectable, Optional } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { environment } from '../../../environments/environment';

export const providePathLocationStrategy = () => [
  {
    provide: PathLocationStrategy,
    useClass: PathPreserveMobileQueryLocationStrategy,
  },
];

/**
 * PathLocationStrategy meant to detect the mobile app query param and preserve it across navigations
 */
@Injectable()
export class PathPreserveMobileQueryLocationStrategy extends PathLocationStrategy {
  private readonly urlSerializer = inject(UrlSerializer);

  private readonly isMobile;

  constructor(_platformLocation: PlatformLocation, @Inject(APP_BASE_HREF) @Optional() _baseHref?: string) {
    super(_platformLocation, _baseHref);
    // Check for the mobile app query param while the app is being instantiated
    this.isMobile = !!_platformLocation.search?.includes(environment.core.mobileAppQueryParam);
  }

  override prepareExternalUrl(internal: string): string {
    const path = super.prepareExternalUrl(internal);
    const tree = this.urlSerializer.parse(path);

    // Re-inject the mobile app query param if it was initially detected
    if (this.isMobile) {
      tree.queryParams = { [environment.core.mobileAppQueryParam]: '', ...tree.queryParams };
    }

    return tree.toString();
  }
}
